import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import {
  MotifModal,
  MotifModalBody,
  MotifModalHeader,
} from '@ey-xd/motif-react';

import { addAttribute } from '../../../common/Attribute';
import EditSecurityForm from '../../../components/masterDataManagement/Securities/EditSecurityForm';

const CreateEditSecurityModal = ({
  isOpen,
  securityFormPurpose,
  initialValues,
  handleSubmit,
  handleDismissErrorMessage,
  isAudit,
  handleCloseSecurityForm,
  reits,
  validationMessage,
  clearValidationMessage,
}) => {
  useEffect(() => {
    //Add Attribute(type=button) to all button elements having attribute(role = 'combobox')
    addAttribute("button[role = 'combobox']", 'type', 'button');
  });

  let modalHeaderText = 'Add New Security';
  if (securityFormPurpose === 'EDIT') {
    modalHeaderText = 'Edit Security';
  }

  return (
    <MotifModal
      show={isOpen}
      onClose={handleCloseSecurityForm}
      variant="alt"
      size="lg"
      data-testid={
        securityFormPurpose === 'EDIT'
          ? 'divEditSecurityModal'
          : 'divAddNewSecurityModal'
      }
    >
      <MotifModalHeader
        data-testid={
          securityFormPurpose === 'EDIT'
            ? 'mdHdrEditSecurity'
            : 'mdHdrCreateNewSecurity'
        }
      >
        <span className="ml-2">{modalHeaderText}</span>
      </MotifModalHeader>
      <EditSecurityForm
        onSubmit={handleSubmit}
        handleCloseForm={handleCloseSecurityForm}
        initialValues={initialValues}
        securityFormPurpose={securityFormPurpose}
        handleDismissErrorMessage={handleDismissErrorMessage}
        isAudit={isAudit}
        reits={reits}
        validationMessage={validationMessage}
        clearValidationMessage={clearValidationMessage}
      />
    </MotifModal>
  );
};

CreateEditSecurityModal.propTypes = {
  isOpen: PropTypes.bool,
  handleCloseSecurityForm: PropTypes.func,
  securityFormPurpose: PropTypes.string,
  initialValues: PropTypes.object,
  error: PropTypes.object,
  submitting: PropTypes.bool,
  handleSecuritySubmit: PropTypes.func,
  handleDismissSecurityErrorMessage: PropTypes.func,
  lookupTypes: PropTypes.object,
  isAudit: PropTypes.bool,
  reits: PropTypes.array,
};

export default CreateEditSecurityModal;
